export default __webpack_public_path__ + "static/media/ReloadIconGreen.149f85a5.svg";